import { render } from "./ActualSwiperElement.vue?vue&type=template&id=8bb80f7e&scoped=true"
import script from "./ActualSwiperElement.vue?vue&type=script&lang=js"
export * from "./ActualSwiperElement.vue?vue&type=script&lang=js"

import "./ActualSwiperElement.vue?vue&type=style&index=0&id=8bb80f7e&scoped=true&lang=scss"
import "./ActualSwiperElement.vue?vue&type=style&index=1&id=8bb80f7e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bb80f7e"]])

export default __exports__